import { Link } from 'react-router-dom';
import { videos } from '@/mocks/videos';

export default function HotVideos() {
  const hotVideos = videos.filter((v) => v.featured).slice(0, 6);

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-600">精选全网高分好剧，追剧不踩坑</p>
          </div>
          <Link
            to="/category/hongtao"
            className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-500 font-medium hover:text-primary-600 transition-colors duration-200 whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {hotVideos.map((video) => (
            <Link
              key={video.id}
              to={`/article/${video.id}`}
              className="group bg-background-50 rounded-2xl overflow-hidden transition-all duration-300 hover:scale-[1.02] cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={video.thumbnail}
                  alt={video.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-primary-500 flex items-center justify-center">
                    <i className="ri-play-fill text-background-50 text-2xl ml-1"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-1 rounded-md bg-black/70 text-background-50 text-xs">
                  {video.duration}
                </div>
                <div className="absolute top-2 left-2 px-2 py-1 rounded-md bg-primary-500 text-background-50 text-xs font-medium">
                  {video.rating}
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-base font-bold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors duration-200">
                  {video.title}
                </h3>
                <p className="text-sm text-foreground-600 line-clamp-2 mb-3">
                  {video.description}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-500 bg-background-100 px-2 py-1 rounded-md">
                    {video.platform}
                  </span>
                  <span className="text-xs text-foreground-500">
                    {video.views > 10000 ? `${(video.views / 10000).toFixed(0)}万次播放` : `${video.views}次播放`}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/hongtao"
            className="inline-flex items-center gap-1 text-sm text-primary-500 font-medium whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}